/**
 * Interpreta e converte expressões de condição de pagamento ("30 60", "3x", "15 +2x") em prazos e
 * datas. Extraído de processo-compras/dialogs/card-edit-dialog/card-edit-dialog.types.ts, que
 * mantém `gerarParcelasDe`/`CotacaoParcela` locais (têm a forma de pagamento `idFormaPagamento`,
 * específica de cotação) e reexporta estas funções para não duplicar a regra de parsing.
 */

/** Meia-noite do dia informado — base estável para converter dias ↔ data de vencimento. */
export function inicioDoDia(data: Date): Date {
  const normalizada = new Date(data);
  normalizada.setHours(0, 0, 0, 0);
  return normalizada;
}

/** Vencimento = data-base + N dias (dias negativos são tratados como zero). */
export function dataPorDias(dataBase: Date, dias: number): Date {
  const data = new Date(dataBase);
  data.setDate(data.getDate() + Math.max(0, Math.trunc(dias || 0)));
  return data;
}

/** Interpreta a expressão de condição de pagamento: "30 60", "3x", "15 +2x". */
export function parseParcelasDias(expr: string): number[] {
  const s = (expr || '').trim();
  if (!s) return [];
  const x = s.match(/^(\d+)\s*x$/i);
  if (x) {
    const n = Math.max(1, Math.min(36, parseInt(x[1], 10)));
    return Array.from({ length: n }, (_, i) => 30 * (i + 1));
  }
  const plus = s.match(/^(\d+)\s*\+\s*(\d+)\s*x$/i);
  if (plus) {
    const first = parseInt(plus[1], 10);
    const extra = parseInt(plus[2], 10);
    const dias = [first];
    for (let i = 1; i <= extra; i++) dias.push(first + 30 * i);
    return dias;
  }
  return s.split(/[\s,;/]+/).map(t => parseInt(t, 10)).filter(n => Number.isFinite(n) && n >= 0);
}
